import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  pageWrapper: {
    backgroundColor: '#ccc',
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    padding: '24px 16px',
    minHeight: 'calc(100vh - 140px)',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 8px'
    }
  },

  breadcrum: {
    width: '100%',
    maxWidth: '122em',
    margin: '0 auto 12px',
    paddingLeft: 28,
    paddingRight: 28,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
      paddingRight: 16
    }
  },

  pageCard: {
    width: '100%',
    maxWidth: '122em',
    margin: '0 auto',
    borderRadius: 16,
    backgroundColor: '#fff',
    overflow: 'hidden',
    boxShadow: '0 2px 18px rgba(0,0,0,0.08)'
  },

  root: {
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    position: 'relative',
    overflowY: 'auto',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    '& .MuiIconButton-root': {
      padding: 4
    },
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxHeight: "100%",
    // backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "400",
    textAlign: 'center',
    margin: 16,
  },

  cardBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '22px 28px 26px',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      padding: 16
    },
  },

  serviceStrip: {
    background: '#f6f0e3',
    borderBottom: '1px solid #ead58b',
    padding: '10px 18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  serviceStripText: {
    margin: 0,
    color: '#8a5b14',
    fontSize: 18,
    fontWeight: 600,
    fontFamily: 'Montserrat',
    textAlign: 'center',
    width: '100%'
  },

  serviceStripLink: {
    color: '#8a5b14',
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  stripCloseIcon: {
    color: '#c17b1d'
  },

  heroTitle: {
    color: '#0f172a',
    fontFamily: 'Montserrat',
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      lineHeight: 1.1
    }
  },

  heroSubTitle: {
    color: '#5b667a',
    fontFamily: 'Montserrat',
    fontSize: 16,
    lineHeight: 1.5,
    textAlign: 'center',
    margin: '8px auto 18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  fieldLabel: {
    color: 'rgb(51, 65, 85)',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8
  },

  notesLabel: {
    color: 'rgb(51, 65, 85)',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  required: {
    color: 'red'
  },

  optionalText: {
    color: '#8f9ab0',
    fontWeight: 500,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  formControl: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      backgroundColor: '#f8fbff'
    }
  },

  propertyLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },

  propertyTooltipIcon: {
    color: '#8ea0ba',
    fontSize: 18,
    cursor: 'pointer',
    marginBottom: 8,
    width: 20,
    height: 20
  },

  consentSection: {
    marginTop: 14,
    '& .MuiFormControlLabel-root': {
      alignItems: 'flex-start',
      marginLeft: 0,
      marginRight: 0
    }
  },

  consentDialogPaper: {
    borderRadius: 16,
    overflow: 'hidden'
  },

  consentDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '14px 20px',
    borderBottom: '1px solid #e6e8ef'
  },

  consentDialogTitle: {
    color: '#1b2233',
    fontFamily: 'Montserrat',
    fontSize: 22,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },

  consentCloseIcon: {
    color: '#8ea0ba',
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  },

  consentDialogBody: {
    padding: '18px 20px 8px',
    maxHeight: '58vh',
    overflowY: 'auto'
  },

  consentHtmlBody: {
    fontFamily: 'Montserrat',
    color: '#5e6d84',
    fontSize: 15,
    lineHeight: 1.5,
    '& .box': {
      margin: 0,
      padding: 0
    },
    '& .info': {
      marginTop: 0,
      marginBottom: 16,
      color: '#5e6d84',
      fontSize: 15,
      lineHeight: 1.5,
      fontFamily: 'Montserrat'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      '& .info': {
        fontSize: 14
      }
    }
  },

  consentDialogFooter: {
    padding: '0 20px 18px'
  },

  consentCloseBtn: {
    width: '100%',
    height: 48,
    borderRadius: 10,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 700
  },

  statusContainer: {
    marginBottom: 20,
    marginTop: 20
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  bodyText: {
    color: "#0C0B0B",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    marginBottom: 30,
    marginTop: 0,
  },

  btn: {
    width: 188,
    fontFamily: "Montserrat",
    fontSize: '1.5em',
    fontWeight: "600",
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
 
  statusTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "700",
    marginTop: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      fontWeight: "600"
    },
  },

  paragraph: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "500",
    [theme.breakpoints.down('sm')]: {
      fontSize: 15
    },  
  },
 
  statusSubTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: "500",
    lineHeight: "30px",
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },

  continueBtn: {
    fontFamily: "Montserrat",
    marginBottom: 20,
    fontSize: '1.4em',
    fontWeight: '600',
    width: 160,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      width: 105,
      height: '30px'
    },
  },

  checkBoxLabel: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "600"
  },
  
  titleBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '12px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  cardIcon: {
    width: 18,
    height: 18,
    color: "#007FFF"
  },

  cardContent2: {
    display: 'flex',
    marginBottom: 20,
    marginTop: 20
  },

  radioBtn: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 5,
      paddingRight: 5
    },
  },

  cardTitleBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '12px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  labelText: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "700",
  },

  textareaSection: {
    '& .MuiFormLabel-root': {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    }
  },

  textArea: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 500,
    width: '100%',
    padding: "10px",
    height: '56px',
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    borderRadius: '12px',
    border: '1px solid #d6dce7',
    backgroundColor: '#f8fbff',
    minHeight: '90px',
    "&::placeholder": {    
      color: '#98a4bb',
      fontSize: '1rem',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      lineHeight: 1
     }
  },

  textBox: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      backgroundColor: '#f8fbff'
    },
    '& .MuiFormLabel': {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    }
  },

  labelAsterisk: {
    color: "red"
  },

  textAreaValidation: {
    color: '#8f9ab0',
    fontSize: 14,
    float: 'right'
  },

  inputStyle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 24
  },
 
  labelStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
  },

  viewconsent: {
    color: '#0a7b73',
    cursor: "pointer",
    textDecoration: 'underline',
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    marginLeft: 42
  },

  infoBox: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#FFF0F0',
    borderRadius: 4,
    padding: '0.5em',
    borderRadius: '4px',
    border: "1px solid #F85757",
  },

  infoTopBox: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#F4F4F4',
    borderRadius: 8,
    padding: '0.5em',
    borderRadius: '4px',
    border: "1px solid #D9D9D9",
    marginBottom: 20,
    marginTop: 5
  },

  feelFree: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: "15px",
    letterSpacing: "0.31px",
    lineHeight: "18px",
    fontWeight: "400",
    padding: 10,
    maxHeight: '100px',
    overflow: "auto"
  },

  closeIcon: {
    position: 'absolute',
    right: 1,
    paddingTop: 8,
    [theme.breakpoints.down('sm')]: {
        right: 2
    }
  },

  icon: {
    marginLeft: 12,
    fontSize: '30px',
    color: '#121D22',
    height: '20px',
    width: '20px',
    cursor: "pointer",
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      height: '16px',
      width: '16px',
      marginLeft: 2
    }
  },

  allSetcloseIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      right: 4,
      top: 6
    }
  },

  inputStyle: {
    color: "#535D6D",
    fontWeight: "500"
  },

  errorMsg: {
    fontSize: '1.4em',
    fontWeight: '600',
    marginBottom: 10,
    marginTop: 10,
    fontFamily: 'Montserrat',
    color: "red"
  },

  validationError: {
    color: "red",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "0.31px",
    lineHeight: "18px",
    marginTop: '5px'
  },

  cardBody2: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '8px 2em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  heading:{
    color: '#198100',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 'normal',
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
},

gotItButton: {
  width: '100%',
  textAlign: 'center',
  backgroundColor: "#fff",
  marginBottom: 30,
  [theme.breakpoints.down('sm')]: {
    padding: '8px 80px 0px',
    width: '94%'
  },
},

 procedureToFill: {
    color: '#1B1B1B',
    fontFamily: "Montserrat",
    fontSize: 14,
    lineHeight: "22px",
    fontWeight: '600'
},

 radioLabel: {
    color: "rgba(0,0,0,0.74)",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: "500",
  },

  marginFixed: {
    marginTop: 14
  },

   resetButton: {
    fontFamily: 'Montserrat',
    letterSpacing: '0.36px',
    fontWeight: '600',
    marginRight: '25px',
    width: '180px',
    height: '40px',
    border: "2px solid",
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    '&:hover': {
      border: "2px solid",
      borderColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '28px',
      marginRight: 0,
      marginTop: 30
    },
  },
  addAccButton: {
    width: '180px',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    textTransform: 'uppercase',
    height: '40px',
  },
  buttonContainer: {
    textAlign: 'center',
    margin: '20px 10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
  },

  primaryCtaBtn: {
    width: '375px',
    padding: '0 28px',
    height: 50,
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      height: 42,
      width: '100%'
    }
  },

  backToSignInBtn: {
    width: '375px',
    height: 50,
    padding: '0 28px',
    textTransform: 'none',
    color: '#535D6D !important',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    boxShadow: '0px 4px 8px 0 rgba(0,0,0,0.14)',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      height: 42,
      fontSize: 16,
      width: '100%'
    }
  },

  successBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 12px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 20px 36px'
    }
  },

  successCheckImage: {
    width: 64,
    height: 64,
    objectFit: 'contain',
    marginBottom: 20
  },

  successTitle: {
    color: '#0f172a',
    fontFamily: 'Montserrat',
    fontSize: 24,
    fontWeight: 800,
    textAlign: 'center',
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },

  successSubTitle: {
    color: '#5b667a',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
    lineHeight: 1.6,
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },

  successPhonePill: {
    border: '1px solid #d7dde8',
    borderRadius: 10,
    padding: '12px 8px',
    backgroundColor: '#f8fbff',
    textAlign: 'center'
  },

  successPhonePillText: {
    color: '#4b5878',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: 400,
    '& strong': {
      color: '#0f172a',
      fontWeight: 700
    }
  },
  
  eligible:{
    color: '#1B1B1B',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 'normal',
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },

  inputDate: {
    color: "#585757",
    fontFamily: "Montserrat",
    fontSize: " 16px",
    fontWeight: '500'
  },
  
  pageHeading: {
    color: '#1A4664',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 25,
    marginTop: 24,
  },

  root: {
    width: '100%',
    margin: '0 auto',
    flexWrap: 'wrap',
    maxWidth: '122em',
    fontFamily: 'Montserrat'
  },

  gotItBtn: {
    padding: '0 28px',
    height: 46,
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 600,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      height: 42
    }
  },
}));
